import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { TRAINER } from "../data";

const LINKS = [
  { label: "About", id: "about" },
  { label: "Method", id: "method" },
  { label: "Services", id: "services" },
  { label: "Reviews", id: "reviews" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.nav
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "bg-[#0A0A0A]/85 backdrop-blur-xl border-zinc-800" : "border-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="w-full max-w-none px-4 md:px-8 lg:px-12 flex items-center justify-between h-20">
        <button onClick={() => go("home")} className="font-display text-xl tracking-tight text-white" data-testid="nav-logo">
          JURADO<span className="text-[#FF3B30]">.</span>PERFORMANCE
        </button>

        <div className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="text-sm font-medium text-zinc-400 hover:text-white transition-colors uppercase tracking-wider"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("book")}
            data-testid="nav-book-btn"
            className="bg-[#FF3B30] text-white px-6 py-3 text-sm font-bold uppercase tracking-wider hover:bg-[#D6281F] transition-colors"
          >
            Free Consult
          </button>
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          <div className="w-6 flex flex-col gap-1.5">
            <span className={`h-0.5 bg-white transition-transform ${open ? "translate-y-2 rotate-45" : ""}`} />
            <span className={`h-0.5 bg-white transition-opacity ${open ? "opacity-0" : ""}`} />
            <span className={`h-0.5 bg-white transition-transform ${open ? "-translate-y-2 -rotate-45" : ""}`} />
          </div>
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0A0A0A] border-t border-zinc-800 px-4 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="text-left text-zinc-300 uppercase tracking-wider text-sm">
              {l.label}
            </button>
          ))}
          <button onClick={() => go("book")} className="bg-[#FF3B30] text-white px-6 py-3 text-sm font-bold uppercase tracking-wider">
            Free Consult
          </button>
        </div>
      )}
    </motion.nav>
  );
};
